<mat-dialog-content align="center">
  <div class="alert-icon-dialog">
    <img [src]="icon" alt="icon.svg" />
  </div>
  <h2 matDialogTitle>{{title | translate}}</h2>
  <span>{{message | translate}}</span>
</mat-dialog-content>
<mat-dialog-actions class="btn-action-dialog">
  <button mat-raised-button matDialogClose="cancel">
    <mat-icon>highlight_off</mat-icon>
    {{(button === 'close' ? 'button.close' : 'button.cancel') | translate}}
  </button>
  @if (button === 'delete') {
  <button mat-raised-button matDialogClose="confirm" color="primary">
    <mat-icon>done</mat-icon>
    {{'button.okay' | translate}}
  </button>
  } @if (button === 'save') {
  <button mat-raised-button matDialogClose="confirm" color="primary">
    <mat-icon>save</mat-icon>
    {{'button.save' | translate}}
  </button>
  } @if (button === 'confirm') {
  <button mat-raised-button matDialogClose="confirm" color="primary">
    <mat-icon>check_circle_outline</mat-icon>
    {{'button.confirm' | translate}}
  </button>
  } @if (button === 'import') {
  <button mat-raised-button matDialogClose="confirm" color="primary">
    <mat-icon svgIcon="import-file"></mat-icon>
    {{'button.import' | translate}}
  </button>
  }
</mat-dialog-actions>
